
import { Vue } from "vue-class-component";
import { LotteryRuleContent } from "../../hooks/LotteryRuleContent";

export default class Algorithm extends Vue {
  algorithm: string[] = [];
  algorithmBlack: string[] = [];
  algorithmRed: string[] = [];
  mounted() {
    this.algorithm = LotteryRuleContent.algorithm;
    this.algorithmBlack = LotteryRuleContent.algorithmBlack;
    this.algorithmRed = LotteryRuleContent.algorithmRed;
  }
}
